import { PreviewPdfLayout } from '@/layouts/PreviewPdfLayout';
import { ResultsPdfModel } from '@/components/Pdf/Models/ResultsPdfModel';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ResultsPreviewPdfPage = () => {
  const { id } = useParams();
  const { t } = useTranslation('inspection');

  const model = <ResultsPdfModel t={t} />;

  return (
    <PreviewPdfLayout filename={`rapport-inspection-${id}`} pdfModel={model}>
      {model}
    </PreviewPdfLayout>
  );
};
